import styled from 'styled-components';
import { IconButton } from '@material-ui/core';

export const ButtonWrapper = styled(IconButton)`
  &&.MuiIconButton-root {
    position: absolute;
    right: 0;
  }
`;
